// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import YouTubePlayer from 'react-player/lib/players/YouTube'
// import VimeoPlayer from 'react-player/lib/players/Vimeo'
import ResponsiveImageMap from 'utilities/ResponsiveImageMap'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

const host = window.location.host

class PageEvents extends React.Component {
	componentWillUnmount() {
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'click', this.handleShareLinkClick )
		window.removeEventListener( 'click', this.handleNotificationsClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
	}

	componentDidMount() {
		this.update()

		// Listen for editor events:
		window.addEventListener( 'dkeEditorVideoUpdated', () => {
			this.updateVideos()
		}, false )
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	update = () => {
		// Links:
		const elements = document.querySelectorAll( '.content-body a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		})

		// Forms:
		const forms = document.querySelectorAll( '.content-body form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )
		})

		// Notifications:
		const notifications = document.querySelectorAll( '.notification' )

		Array.from( notifications ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleNotificationsClick )
		})

		// Parallax:
		// const parallaxes = document.querySelectorAll( '.parallax' )

		// Array.from( parallaxes ).forEach( ( element ) => {

		// })

		// Videos:
		this.updateVideos()

		// Image Maps:
		const imageMaps = document.querySelectorAll( '.content-body .image-map' )

		Array.from( imageMaps ).forEach( ( element ) => {
			let map = element.querySelector( 'map' )
			let img = element.querySelector( 'img' )
			let width = img.getAttribute( 'data-width' )

			img.onload = () => {
				new ResponsiveImageMap( map, img, width )
			}

			// Ensure onload gets called when image is cached:
			img.src = img.src
		})
	}

	updateVideos = () => {
		// Videos:
		// this.player = plyr.setup()

		// Array.from( this.player ).forEach( ( player ) => {
		// 	player.on( 'pause', ( e ) => {
		// 		e.target.classList.add( 'is-paused' )
		// 	})
		// })

		// Video share links:
		const shareLinks = document.querySelectorAll( '.media-player .-toggle-share-links' )

		Array.from( shareLinks ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleShareLinkClick )
		})
	}

	handleNotificationsClick = ( e ) => {
		e.currentTarget.classList.toggle( 'is-closed' )
	}

	handleShareLinkClick = ( e ) => {
		let parent = e.currentTarget.parentNode

		parent.classList.toggle( 'with-share-links-open' )
	}

	handleLinkClick = ( e ) => {
		let href = e.currentTarget.getAttribute( 'href' )
		href = href.replace( /^(\.+)/g, '' )

		if ( href.indexOf( host ) > -1 && href.indexOf( '//' ) > -1 ) {
			window.location( href ) // Same network, different site, open normally.
		} else if ( href.indexOf( '//' ) > -1 ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash
		} else {
			history.push( href ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmit = ( e ) => {
		const form = e.currentTarget
		const buttons = form.querySelectorAll( 'button' )
		const formData = new FormData( form )
		formData.append( 'action', 'nzpuc_theme_formidable_submit_form' )

		e.preventDefault()

		// Disable the button:
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// Submit:
		doRequest( siteData.ajax_url, {
			method: 'POST',
			body: formData
		})
			.then( message => {
				// Success:

				form.classList.remove( 'has-error' )
				form.setAttribute( 'data-message', '' )

				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-successful' )

					// Set the success message:
					message && form.setAttribute( 'data-message', message )

					setTimeout( () => {
						form.classList.remove( 'is-successful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}

						// Clear the form:
						form.reset()
					}, 1000 )
				}, 1000 )
			})
			.catch( error => {
				// Error:

				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-unsuccessful' )

					// Set the error text:
					form.classList.add( 'has-error' )
					error && form.setAttribute( 'data-message', error )

					setTimeout( () => {
						form.classList.remove( 'is-unsuccessful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}
					}, 3000 )
				}, 1000 )
			})
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageEvents )



// WEBPACK FOOTER //
// ./views/main/page/PageEvents.jsx